import React, { useState, useEffect } from 'react';
import { spacesAPI } from '../services/api';
import SpaceCard from '../components/SpaceCard';
import { FaSearch } from 'react-icons/fa';

const SpaceListPage = () => {
  const [spaces, setSpaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    city: '',
    spaceType: '',
    minPrice: '',
    maxPrice: '',
  });

  useEffect(() => {
    fetchSpaces();
  }, []);

  const fetchSpaces = async () => {
    try {
      setLoading(true);
      const response = await spacesAPI.getAll(filters);
      setSpaces(response.data);
    } catch (error) {
      console.error('Error fetching spaces:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchSpaces();
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-8 text-blue-800">Find Your Perfect Space</h1>

        {/* Search Filters */}
        <form onSubmit={handleSearch} className="bg-white p-6 rounded-lg shadow-md mb-8">
          <div className="grid md:grid-cols-4 gap-4">
            <input
              type="text"
              name="city"
              placeholder="City"
              value={filters.city}
              onChange={handleFilterChange}
              className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <select
              name="spaceType"
              value={filters.spaceType}
              onChange={handleFilterChange}
              className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Types</option>
              <option value="shop">Shop</option>
              <option value="office">Office</option>
              <option value="storage">Storage</option>
              <option value="warehouse">Warehouse</option>
              <option value="other">Other</option>
            </select>
            <input
              type="number"
              name="minPrice"
              placeholder="Min Price"
              value={filters.minPrice}
              onChange={handleFilterChange}
              className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="number"
              name="maxPrice"
              placeholder="Max Price"
              value={filters.maxPrice}
              onChange={handleFilterChange}
              className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <button
            type="submit"
            style={{ backgroundColor: '#2563eb' }}
            className="mt-4 w-full text-white py-3 rounded-lg transition flex items-center justify-center hover:opacity-90"
          >
            <FaSearch className="mr-2" />
            Search Spaces
          </button>
        </form>

        {/* Spaces Grid */}
        {loading ? (
          <div className="text-center py-12">
            <div style={{ borderTopColor: '#2563eb', borderBottomColor: '#2563eb' }} className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2"></div>
            <p className="mt-4 text-gray-600">Loading spaces...</p>
          </div>
        ) : spaces.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600">No spaces found matching your criteria.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {spaces.map((space) => (
              <SpaceCard key={space._id} space={space} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SpaceListPage;
